import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="forgot-pwd-page" className="public-light bg-[#050505] min-h-screen text-[#F5F2EB]">
      <Navbar/>
      <section className="pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-md mx-auto border border-white/10 bg-[#0A0A0A] p-8 md:p-12">
          <div className="overline mb-3">Account recovery</div>
          <h1 className="font-serif text-3xl mb-2">Reset your password</h1>
          {sent ? (
            <div data-testid="forgot-sent" className="text-sm text-[#A1A1AA] leading-relaxed mt-6">
              <p className="mb-4">If that email is on file, we've sent you a link. Open the link within an hour to set a new password.</p>
              <Link to="/login" className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]">← Back to sign in</Link>
            </div>
          ) : (
            <>
              <p className="text-[#A1A1AA] text-sm mb-6">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="space-y-3">
                <input data-testid="forgot-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="w-full bg-black border border-white/10 px-4 py-3 text-sm focus:border-[#D4AF37] outline-none"/>
                <button data-testid="forgot-submit" type="submit" disabled={busy}
                  className="w-full bg-[#D4AF37] text-black py-3.5 font-medium uppercase tracking-[0.18em] text-xs hover:opacity-90 disabled:opacity-60 transition">
                  {busy ? "…" : "Send reset link"}
                </button>
              </form>
              <div className="text-center mt-4">
                <Link to="/login" className="text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] hover:text-[#D4AF37]">← Back to sign in</Link>
              </div>
            </>
          )}
        </div>
      </section>
      <Footer/>
    </div>
  );
}
